<form>
  <div mat-dialog-content class="thermal-theme" fxLayout="column">

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + data.type + '.responsible' | translate }}</mat-label>
          <mat-select name="bioindicatorsResponsible" [(ngModel)]="data.responsible">
            @for (responsible of bioindicatorResponsibles; track responsible) {
            <mat-option [value]="responsible.id">
              {{ 'bioindicatorResponsibleType.' + responsible.translation | translate }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + data.type + '.number' | translate }}</mat-label>
          <input matInput type="number" required [(ngModel)]="bioCount" (change)="resetChecks()"
            [max]="data.sensors.length" [min]="1" name="bioCount">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.' + data.type + '.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      @if (data.sensors.length != bioCount) {
      <div fxFlex="100%" fxFlex.lt-md="100%">
        @for (sensor of data.sensors; track sensor; let indexSensor = $index) {
        <div fxLayout="row" class="flexwrap">
          <div fxFlex="20" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.essay.sensors.sensorNum.label' | translate }}</mat-label>
              <input matInput name="numSensor{{indexSensor}}" value="{{ indexSensor + 1 }}" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="70" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.essay.sensors.location.label' | translate }}</mat-label>
              <input matInput name="numSensor{{indexSensor}}" [(ngModel)]="sensor.location" disabled>
            </mat-form-field>
          </div>
          <div fxFlex="10" fxFlex.lt-md="100%">
            <mat-checkbox [name]="'bio' + indexSensor" class="example-margin" (change)="onChangeCheck($event)"
              [value]="sensor" [checked]="checked[sensor.location]" [disabled]="disableChecks(sensor)"></mat-checkbox>
          </div>
        </div>
        }
      </div>
      }

      <div fxFlex="100%" fxFlex.lt-md="100%" style="margin-top: 1.5em">

        <div fxFlex></div>

        <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.accept' | translate }}</button>

        <div fxFlex="5px"></div>

        <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
      </div>

    </div>
  </div>
</form>